"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const burst = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 37 37",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-burst` : '') + (description ? ` desc-burst` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-burst"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-burst"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.125 0.25V6.5H18.375V0.25H17.125ZM17.125 30.25V36.5H18.375V30.25H17.125ZM24.8081 9.80806L31.0581 3.55806L31.9419 4.44194L25.6919 10.6919L24.8081 9.80806ZM4.76716 1.52179L12.2672 10.6469L13.2328 9.85315L5.73284 0.728087L4.76716 1.52179ZM13.1133 27.0086L4.36327 33.2586L3.63673 32.2414L12.3867 25.9914L13.1133 27.0086ZM31.9419 32.3081L25.6919 26.0581L24.8081 26.9419L31.0581 33.1919L31.9419 32.3081ZM31.5 15.875H36.5V17.125H31.5V15.875ZM5.25 15.875H0.25V17.125H5.25V15.875Z"
  }));
};
var _default = exports.default = burst;